import PropTypes from "prop-types"
import React from "react"

import Card from "src/components/Card"
import ProfileImage from "src/components/ProfileImage"

const ContactCard = ({ data, link }) => {
  return (
    <Card href={link} withShadow={false}>
      <div className="flex items-center justify-between p-4">
        <div className="flex space-x-4">
          <ProfileImage
            imageUrl={data.thumbnail_url}
            name={data.avatar_initial}
            backgroundColor={data.avatar_background_color}
          />
          <div className="flex flex-col">
            <span className="font-semibold">{data.name}</span>
            <span className="text-gray-600">
              {data.city} {data.state}
            </span>
          </div>
        </div>
        <i className="icon icon-sf-chevron-right text-xs text-gray-600" />
      </div>
    </Card>
  )
}

ContactCard.propTypes = {
  data: PropTypes.shape({
    thumbnail_url: PropTypes.string,
    avatar_initial: PropTypes.string,
    avatar_background_color: PropTypes.string,
    name: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
  }).isRequired,
  link: PropTypes.string.isRequired,
}

export default ContactCard
